/**
 * icons.jsx — Icon registry for project cards.
 *
 * Add new icons here and reference them by key in src/content/projects.json.
 * Example: "icon": "nova-star" in projects.json maps to ICONS["nova-star"] here.
 */

export const ICONS = {
  'nova-star': (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <defs>
        <linearGradient id="novaStarGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%"   stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      <path
        d="M12 2 L14.5 9.5 L22 12 L14.5 14.5 L12 22 L9.5 14.5 L2 12 L9.5 9.5 Z"
        fill="url(#novaStarGrad)"
        stroke="url(#novaStarGrad)"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
};
